import { Button, Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';


const defaultProps = {
  onSave: null,
  onPreview: null,
};
const propTypes = {
  onSave: PropTypes.func,
  onPreview: PropTypes.func,
};

const Buttons = ({ onSave, onPreview }) => (
  <div className="ml-lg mb-md">
    <Button size="small" onClick={onSave}>
      <Icon type="save" className="icon-thinner font-sm" />
      <FormattedMessage id="global.ui.button.save" />
    </Button>
    <Button className="ml-sm" size="small" onClick={onPreview}>
      <Icon type="eye" className="icon-thinner font-sm" />
      <FormattedMessage id="global.ui.button.preview" />
    </Button>
  </div>
);

Buttons.defaultProps = defaultProps;
Buttons.propTypes = propTypes;
export default Buttons;



// WEBPACK FOOTER //
// ./src/views/ReportFilters/components/Actions/components/Buttons.jsx